import { z } from 'zod'
import { widgetSettingsSchema } from './settings'

/**
 * The document the storefront widget reads from KV at the edge (SW-304).
 *
 * Deliberately small and free of anything secret: it is served to any origin the shop owns
 * and is cached at the edge, so it must be safe to treat as public.
 */
export const widgetConfigSchema = z.object({
  v: z.literal(1),
  shopDomain: z.string(),
  /** False when the shop uninstalled or the merchant disabled the widget, render nothing. */
  active: z.boolean(),
  widget: widgetSettingsSchema,
  consentCopy: z.string(),
  consentCopyVersion: z.string(),
  doubleOptIn: z.boolean(),
  smsEnabled: z.boolean(),
  turnstileSiteKey: z.string().nullable(),
  apiBase: z.string(),
  /** Storefront origins allowed to call the subscribe endpoint, including custom domains. */
  origins: z.array(z.string()),
  updatedAt: z.number().int(),
})

export type WidgetConfig = z.infer<typeof widgetConfigSchema>

export function widgetConfigKey(shopDomain: string): string {
  return `widget:v1:${shopDomain}`
}
